import { Component, HostBinding, inject } from '@angular/core';

import { ARCConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { UserService } from '@frontend/sports/user/feature';
import { DsButton } from '@frontend/ui/button';
import { ProductHomepagesConfig, WINDOW } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { WidgetComponent } from '../widget/core/widget-registry.service';

@Component({
    selector: 'ms-panic-button',
    templateUrl: './panic-button.component.html',
    imports: [IconCustomComponent, DsButton, SportsThemedButtonDirective],
})
export class PanicButtonComponent extends WidgetComponent<never> {
    @HostBinding('class') className = 'panic-button-widget';

    isPanicButtonEnabled: boolean;
    readonly buttonThemeInverse: ThemeOptions<boolean> = { oddset: true };

    constructor(
        public sitecore: Sitecore,
        private productHomepagesConfig: ProductHomepagesConfig,
        public m2User: UserService,
        private aRCConfig: ARCConfig,
    ) {
        super();

        this.isPanicButtonEnabled = this.aRCConfig.showSelfExclusionLock;
    }

    onPanicClick(): void {
        this._window.location.href = this.productHomepagesConfig.portal + this.sitecore.panicButtonMessages.PanicButtonPath;
    }

    private readonly _window = inject(WINDOW);
}
